import request from './request'

export const Getme = ()  => request.get('/api/me')//获取用户信息
export const LoginStudent = params  => request.post('/api/loginStudent',params) //学生登录



export const GetUserInfo = params  => request.get('/xstWxUser/getUserInfo',{ params: params })//扫码获取code
export const GetUser = params  => request.get('/xstWxUser/getUser',{ params: params })//获取用户信息
export const UpdateUser = params  => request.post('/xstWxUser/updateUser',params)//完善用户信息

export const CreateNative = params  => request.get('/wxPay/createNative',{ params: params })//调起支付二维码

export const GetPayResult = params  => request.get('/wxPay/getPayResult',{ params: params })//起查询支付状态接口

export const GetOrderList = params  => request.get('/xszpOrder/getOrderList',{ params: params })// 根据userId获取订单列表

export const GetOrderInfo = params  => request.get('/xszpOrder/getOrderInfo',{ params: params })// 根据orderno获取订单详情中的用户

export const GetUserInfoByid = params  => request.get('/xstWxUser/getUserInfoByid',{ params: params })// 获取根据id获取用户信息

export const UpdateOrderno = params  => request.get('/xszpOrder/updateOrderno',{ params: params })//根据oid,orderno修改添加作品信息

export const Inscgzp = params  => request.get('/xszpOrder/inscgzp',{ params: params })//新增成果展评

export const Updatecgzp = params  => request.get('/xszpOrder/updatecgzp',{ params: params })//修改成果展评

export const GetCgzpList = params  => request.get('/xszpOrder/getCgzpList',{ params: params })//根据userid获取成果展评列表

export const GetCgzpInfo = params  => request.get('/xszpOrder/getCgzpInfo',{ params: params })//根据wid获取成果展评详细



